import type { FunctionComponent } from 'react';
import EcoSystem from './EcoSystem/EcoSystem';
import OIDC from './OIDC/OIDC';
import Trello from './Trello/Trello';
import AppLinks from './AppLinks';
import { useToken } from '../Flow/ConsentContextProvider';
import Rovo from './Rovo/Rovo';
import PartnerCentral from './PartnerCentral/PartnerCentral';
import Bitbucket from './Bitbucket/Bitbucket';
import TWG from './TWG/TWG';
import A2A from './A2A/A2A';
import DAG from './DAG/DAG';

const MainContent: FunctionComponent = () => {
  const { serviceType } = useToken();

  switch (serviceType) {
    case 'Ecosystem':
      return <EcoSystem />;
    case 'OIDC':
      return <OIDC />;
    case 'Trello':
      return <Trello />;
    case 'Applinks':
      return <AppLinks />;
    case 'Rovo':
      return <Rovo />;
    case 'PartnerCentral':
      return <PartnerCentral />;
    case 'Bitbucket':
      return <Bitbucket />;
    case 'TWG':
      return <TWG />;
    case 'A2A':
      return <A2A />;
    case 'DAG':
      return <DAG />;
  }
};

export default MainContent;
